export const AUTH_DATA_FETCH = '@@auth/FETCH_AUTH_DATA';
export const AUTH_DATA_SUCCESS = '@@auth/AUTH_DATA_SUCCESS';
export const AUTH_DATA_FAILURE = '@@auth/AUTH_DATA_FAILURE';
export const LOGOUT_USER = '@@auth/LOGOUT_USER';



// WEBPACK FOOTER //
// ./src/redux/auth/types.js